import { List } from "antd";
import "./list.scss";
export default List;
